/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pricing_Pack_CreditsInputs */

const en_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} credits`)
};

const de_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Credits`)
};

const fr_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} credits`)
};

const es_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} creditos`)
};

const it_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} crediti`)
};

const nl_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} credits`)
};

const pl_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kredytow`)
};

const fi_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} krediittiä`)
};

const da_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} credits`)
};

const sv_pricing_pack_credits = /** @type {(inputs: Pricing_Pack_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} krediter`)
};

/**
* | output |
* | --- |
* | "{count} credits" |
*
* @param {Pricing_Pack_CreditsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_pack_credits = /** @type {((inputs: Pricing_Pack_CreditsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Pack_CreditsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_pack_credits(inputs)
	if (locale === "fr") return fr_pricing_pack_credits(inputs)
	if (locale === "es") return es_pricing_pack_credits(inputs)
	if (locale === "it") return it_pricing_pack_credits(inputs)
	if (locale === "nl") return nl_pricing_pack_credits(inputs)
	if (locale === "pl") return pl_pricing_pack_credits(inputs)
	if (locale === "fi") return fi_pricing_pack_credits(inputs)
	if (locale === "da") return da_pricing_pack_credits(inputs)
	if (locale === "sv") return sv_pricing_pack_credits(inputs)
	return en_pricing_pack_credits(inputs)
});